import { createActionCreator } from 'deox';
import { Paging, Country } from '@/types';

export const fetchCountriesActions = {
  request: createActionCreator('FETCH_COUNTRIES_REQUEST', (resolve) => () => resolve()),
  success: createActionCreator(
    'FETCH_COUNTRIES_SUCCESS',
    (resolve) => (data: Country[], paging: Paging, meta: { authors: string[] }) => resolve({ data, paging, meta })
  ),
  failure: createActionCreator('FETCH_COUNTRIES_FAILURE', (resolve) => (error: any) => resolve({ error })),
};
